import type { CbiFrontendServiceContext } from "../../frontend/context/CbiFrontendServiceContext";
import type { AgreementCategoryStaff } from "./AgreementCategoryStaff";
import type { AgreementDTOBase } from "./AgreementDTOBase";
import type { AgreementInstanceStaff } from "./AgreementInstanceStaff";
import type { CatalogItemAgreementStaff } from "./CatalogItemAgreementStaff";
import type { CatalogRef } from "./CatalogRef";
import type { CatalogStaff } from "./CatalogStaff";

export class AgreementStaff implements AgreementDTOBase {
  constructor(public readonly assignId: number, public readonly catalogId: CatalogStaff | null, public readonly agreementName: string | null, public readonly isGlobal: boolean | null, public readonly sortOrder: number | null, public readonly items: Array<CatalogItemAgreementStaff> | null, public readonly agreementInstances: Array<AgreementInstanceStaff> | null, public readonly agreementCategories: Array<AgreementCategoryStaff> | null, public readonly catalogIdTargetIds: CatalogRef) {
    this.cbiServiceContext = null;
    this.catalogIdLoaded = this.catalogId != null;
    this.catalogIdCached = this.catalogId;
    this.itemsLoaded = this.items != null;
    this.itemsCached = this.items;
    this.agreementInstancesLoaded = this.agreementInstances != null;
    this.agreementInstancesCached = this.agreementInstances;
    this.agreementCategoriesLoaded = this.agreementCategories != null;
    this.agreementCategoriesCached = this.agreementCategories;
  }
  cbiServiceContext: CbiFrontendServiceContext | null;
  private catalogIdLoaded: boolean;
  private catalogIdCached: CatalogStaff | null;
  private itemsLoaded: boolean;
  private itemsCached: Array<CatalogItemAgreementStaff> | null;
  private agreementInstancesLoaded: boolean;
  private agreementInstancesCached: Array<AgreementInstanceStaff> | null;
  private agreementCategoriesLoaded: boolean;
  private agreementCategoriesCached: Array<AgreementCategoryStaff> | null;
  async catalogIdLazy(): Promise<CatalogStaff> {
    if (!this.catalogIdLoaded) {
      this.catalogIdCached = await this.cbiServiceContext!.catalogService().getCatalogStaff(this.catalogIdTargetIds.assignId);
      this.catalogIdLoaded = true;
    }
    return this.catalogIdCached!;
  }
  async itemsLazy(): Promise<Array<CatalogItemAgreementStaff>> {
    if (!this.itemsLoaded) {
      this.itemsCached = await this.cbiServiceContext!.catalogService().getAgreementStaffItems(this.assignId);
      this.itemsLoaded = true;
    }
    return this.itemsCached!;
  }
  async agreementInstancesLazy(): Promise<Array<AgreementInstanceStaff>> {
    if (!this.agreementInstancesLoaded) {
      this.agreementInstancesCached = await this.cbiServiceContext!.catalogService().getAgreementStaffAgreementInstances(this.assignId);
      this.agreementInstancesLoaded = true;
    }
    return this.agreementInstancesCached!;
  }
  async agreementCategoriesLazy(): Promise<Array<AgreementCategoryStaff>> {
    if (!this.agreementCategoriesLoaded) {
      this.agreementCategoriesCached = await this.cbiServiceContext!.catalogService().getAgreementStaffAgreementCategories(this.assignId);
      this.agreementCategoriesLoaded = true;
    }
    return this.agreementCategoriesCached!;
  }
}
